import React from 'react';
import PropTypes from 'prop-types';
import AccountsDedicatedInvoiceBody from './AccountsDedicatedInvoiceBody';
import useCheckTwoDepartments from '../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { ACCOUNTS, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import AccountsNavBar from '../../../../layouts/accounts/AccountsNavBar';

const AccountsDedicatedInvoice = ({ history }) => {
  useCheckTwoDepartments(`${ACCOUNTS}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AccountsNavBar currentPage="Dedicated Invoice" position={firstName} />
        <AccountsDedicatedInvoiceBody />
      </main>
    </div>
  );
};

AccountsDedicatedInvoice.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default AccountsDedicatedInvoice;
